import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Avatar/Avatar.docs.json';
import { Avatar, Box } from '@primer/react';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/design/components/avatar/react'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Avatar} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Avatar src="https://avatars.githubusercontent.com/primer" />
`}</code></pre>
    <h3>{`Square`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Avatar square src="https://avatars.githubusercontent.com/primer" />
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      